import { securityDecode } from "./awsConfig";

export const getCodeSecurity = () => {
  return securityDecode[0].password;
};